import React from 'react';
import { Outlet } from 'react-router-dom';

const CompanyOutlet = () => {
  return (
    <>
        <Outlet />
    </>
  )
}

export default CompanyOutlet
